var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.7,
    height: 21.7,
    viewBox: "0 0 19.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(-2.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2701",
    "data-name": "Group 2701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    d: "M2-.85H16A2.853,2.853,0,0,1,18.85,2V9A2.853,2.853,0,0,1,16,11.85H2A2.853,2.853,0,0,1-.85,9V2A2.853,2.853,0,0,1,2-.85Z",
    transform: "translate(3 11)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M17,11.85a.85.85,0,0,1-.85-.85V7a4.15,4.15,0,0,0-8.3,0v4a.85.85,0,1,1-1.7,0V7a5.85,5.85,0,0,1,11.7,0v4A.85.85,0,0,1,17,11.85Z",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlue);
export default __webpack_public_path__ + "static/media/lockBlue.10f59dcc6ae0c7af4615255fd03618fb.svg";
export { ForwardRef as ReactComponent };